
import { Get } from "@/api/axios.config";

export function getPrivacyPolicy({
    type = 1
}){
    return Get({
        url: "v2/app/privacy_policy/get",
        data: {
            type
        }
    });
}


// WEBPACK FOOTER //
// ./src/pages/normal/protocol/api/api.js